<div class="sectionContent"></div>
<div class="frame-parent" *ngIf="isEntryPage">
    <div class="citations">
        <div class="help">Help</div>
        <div class="summary">
              <span class="normal-text">
                <a class="search-help-link vf-section-header__heading--is-link" href="https://www.ebi.ac.uk/training/online/courses/alphafold/ " target="_blank"
                 (click)="gaService.eventEmitter('link_visit', 'training_href_click', 'click', 'training_entry_page_link', 'Clicks on the training link on every entry page')">
                <span style="display: inline-block; vertical-align: middle;">Go to AlphaFold training course</span>
                <span style="display: inline-block; vertical-align: middle; padding-top: 2px">
                  <svg aria-hidden="true" class="vf-section-header__icon | vf-icon vf-icon-arrow--inline-end" width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                    <path d="M0 12c0 6.627 5.373 12 12 12s12-5.373 12-12S18.627 0 12 0C5.376.008.008 5.376 0 12zm13.707-5.209l4.5 4.5a1 1 0 010 1.414l-4.5 4.5a1 1 0 01-1.414-1.414l2.366-2.367a.25.25 0 00-.177-.424H6a1 1 0 010-2h8.482a.25.25 0 00.177-.427l-2.366-2.368a1 1 0 011.414-1.414z" fill="#3B6FB6" fill-rule="nonzero"></path>
                  </svg>
                </span>
              </a>
              </span>
        
            <app-faqs-list [paeExplaination]="true"
            (click)="gaService.eventEmitter('pae-help-click', 'pae', 'click', accession, undefined)"></app-faqs-list>
            <app-faqs-list [tedExplaination]="true"
            (click)="gaService.eventEmitter('domains_help_click', 'training_href_click', 'click', accession, 'Clicks that expand the tutorial section of the Domains on the entry page')"></app-faqs-list>
        </div>
    </div>
    <div class="citations" id="last-updated">
        <div class="help">Last updated</div>
        <div class="summary">
            <div class="structure-prediction-last">Last updated in AlphaFold DB version {{ providerData?.modelCreatedDate | date:'yyyy-MM-dd' }}, created with the {{providerData?.toolUsed}}.</div>
        </div>
    </div>
    <div class="citations" id="licence-and-attribution">
            <div class="help">Licence and attributions </div>
            <div class="summary1">
                <div class="data-is-available-container">
                    <p class="data-is-available-for-academic">
                        <span>
                            <span class="data-is-available">Data is available for academic and commercial use, under a </span>
                            <span class="alphafolddeepmindcom"><a target="_blank" href="https://creativecommons.org/licenses/by/4.0/" class="licenseLink"> {{providerData?.license}}</a></span>
                            <span> license. </span>
                        </span>
                    </p>
                    <p class="data-is-available-for-academic">
                        <span>
                            <span>&nbsp;</span>
                        </span>
                    </p>
                    <p class="data-is-available-for-academic">
                        <span>
                            <span>EMBL-EBI expects attribution (e.g. in publications, services or products) for any of its online services, databases or software in accordance with good scientific practice. If you make use of this prediction, please cite:</span>
                        </span>
                    </p>

                    <p class="jumper-j-et-al-highly-accura" *ngFor="let cit of providerData?.citations">
                        <span>
                            <span>
                                <a class="licenseLink" (click)="gaService.eventEmitter('link_visit','home_href_click','click','methods_paper','')" href="{{ cit.url }}" target="_blank" [innerHTML]="cit.description.replace('et al.', '<i>et al.</i>')"></a><br>
                            </span>
                        </span>
                    </p>

                    <p class="jumper-j-et-al-highly-accura">
                        <span>
                            <span>
                                <a class="licenseLink" (click)="gaService.eventEmitter('link_visit','home_href_click','click','methods_paper','')" href="https://www.sciencedirect.com/science/article/pii/S0022283625000336" target="_blank">
      Fleming J. <i>et al</i>. AlphaFold Protein Structure Database and 3D-Beacons: New Data and Capabilities. Journal of Molecular Biology, (2025) </a><br>
                            </span>
                        </span>
                    </p>
                    <p class="data-is-available-for-academic">
                        <span>
                            <span>&nbsp;</span>
                        </span>
                    </p>
                    <p class="data-is-available-for-academic">
                        <span>
                            <span>If you use data from AlphaMissense in your work, please cite the following papers:</span>
                        </span>
                    </p>
                    <p class="jumper-j-et-al-highly-accura">
                        <a class="licenseLink" href="https://www.science.org/doi/10.1126/science.adg7492" target="_blank">
                            <span>
                                    <span>Cheng, J <i>et al</i>. Accurate proteome-wide missense variant effect prediction with AlphaMissense. Science (2023).</span>
                            </span>
                        </a>
                    </p>
                    <p class="data-is-available-for-academic">
                        <span>
                            <span>&nbsp;</span>
                        </span>
                    </p>
                    <p class="data-is-available-for-academic">
                        <span *ngFor="let item of providerData?.copyrights">
                            <span>{{ item }}</span><br>
                        </span>
                    </p>
                </div>
            </div>
        </div>
    <div class="citations">
        <div class="help">Feedback</div>
        <div class="summary-wrapper">
            <div class="summary2">
                <div class="if-you-want-container">
                    <span>If you want to share feedback on an AlphaFold structure prediction, consider using the feedback buttons at the top of each structure page. If you have any questions that are not covered in the  <a href="/faq" target="_blank" class="licenseLink">FAQs</a>,</span> <span> please contact </span>
                    <span class="alphafolddeepmindcom"><a href="mailto:{{providerData?.feedback}}" class="licenseLink">alphafold&#64;deepmind.com</a></span>
                    <span>. If you have feedback on the website or experience any bugs please contact </span>
                    <span class="alphafolddeepmindcom"><a href="mailto:afdbhelp@ebi.ac.uk" class="licenseLink">alphafolddb&#64;ebi.ac.uk</a></span>
                    <span class="span">.  </span>
                    <br /><br />
                    <span>Let us know how the AlphaFold Protein Structure Database has been useful in your research at  <a href="mailto:{{providerData?.feedback}}" class="licenseLink">alphafold&#64;deepmind.com</a>.</span>

                </div>
            </div>
        </div>
    </div>
    <div class="citations">
        <div class="help" >Disclaimer</div>
        <div class="summary-wrapper">
            <div class="disclaimer1">
                <div class="data-is-available-container">
                    <p class="data-is-available-for-academic">The AlphaFold Data and other information provided on this site is for theoretical modelling only, caution should be exercised in its use. It is provided 'as-is' without any warranty of any kind, whether expressed or implied. For clarity , no warranty is given that use of the information shall not infringe the rights of any third party. The information is not intended to be a substitute for professional medical advice, diagnosis, or treatment, and does not constitute medical or other professional advice. </p>
                    <p class="data-is-available-for-academic">&nbsp;</p>
                    <p class="jumper-j-et-al-highly-accura">
                        <span class="data-is-available">Use of the AlphaFold Protein Structure Database is subject to EMBL-EBI </span>
                        <a class="licenseLink" href="https://www.ebi.ac.uk/about/terms-of-use/" target="_blank">
                                <span>Terms of Use</span>
                        </a>
                        <span class="data-is-available">.</span>
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="frame-parent" style="margin-bottom: 32px;"  *ngIf="isEntryPage == false">
    <div class="citations" id="last-updated">
        <div class="help">Last updated</div>
        <div class="summary">
            <div class="structure-prediction-last">Last updated in AlphaFold DB version 2022-11-01, created with the AlphaFold Monomer v2.0 pipeline.</div>
        </div>
    </div>
    <div class="citations" id="licence-and-attribution">
            <div class="help">Licence and attributions </div>
            <div class="summary1">
                <div class="data-is-available-container">
                    <p class="data-is-available-for-academic">
                        <span>
                            <span class="data-is-available">Data is available for academic and commercial use, under a </span>
                            <span class="alphafolddeepmindcom"><a target="_blank" href="https://creativecommons.org/licenses/by/4.0/" class="licenseLink">CC-BY-4.0</a></span>
                            <span> license. </span>
                        </span>
                    </p>
                    <p class="data-is-available-for-academic">
                        <span>
                            <span>&nbsp;</span>
                        </span>
                    </p>
                    <p class="data-is-available-for-academic">
                        <span>
                            <span>EMBL-EBI expects attribution (e.g. in publications, services or products) for any of its online services, databases or software in accordance with good scientific practice. If you make use of this prediction, please cite:</span>
                        </span>
                    </p>
                    <p class="jumper-j-et-al-highly-accura">
                        <span>
                            <span>
                                <a class="licenseLink" (click)="gaService.eventEmitter(
      'link_visit',
      'home_href_click',
      'click',
      'methods_paper',
      '')" href="https://www.nature.com/articles/s41586-021-03819-2" target="_blank">
        Jumper, J <i>et al</i>. Highly accurate protein structure prediction with AlphaFold. <i>Nature</i> (2021).</a><br>

                            </span>
                        </span>
                    </p>
                    <p class="jumper-j-et-al-highly-accura">
                        <span>
                            <span>
                                <a class="licenseLink" (click)="gaService.eventEmitter(
      'link_visit',
      'home_href_click',
      'click',
      'methods_paper',
      '')" href="https://www.sciencedirect.com/science/article/pii/S0022283625000336" target="_blank">
      Fleming J. <i>et al</i>. AlphaFold Protein Structure Database and 3D-Beacons: New Data and Capabilities. Journal of Molecular Biology, (2025) </a><br>

                            </span>
                        </span>
                    </p>
                    <p class="data-is-available-for-academic">
                        <span>
                            <span>&nbsp;</span>
                        </span>
                    </p>
                    <p class="data-is-available-for-academic">
                        <span>
                            <span>If you use data from AlphaMissense in your work, please cite the following papers:</span>
                        </span>
                    </p>
                    <p class="jumper-j-et-al-highly-accura">
                        <a class="licenseLink" href="https://www.science.org/doi/10.1126/science.adg7492" target="_blank">
                            <span>
                                    <span>Cheng, J <i>et al</i>. Accurate proteome-wide missense variant effect prediction with AlphaMissense. Science (2023).</span>
                            </span>
                        </a>
                    </p>
                    <p class="data-is-available-for-academic">
                        <span>
                            <span>&nbsp;</span>
                        </span>
                    </p>
                    <p class="data-is-available-for-academic">
                        <span>
                            <span>AlphaFold Data Copyright (2022) DeepMind Technologies Limited.</span>
                        </span><br>
                        <span>
                            <span>AlphaFold Data Copyright (2023) DeepMind Technologies Limited.</span>
                        </span>
                    </p>
                </div>
            </div>
        </div>
    <div class="citations">
        <div class="help">Feedback</div>
        <div class="summary-wrapper">
            <div class="summary2">
                <div class="if-you-want-container">
                    <span>If you want to share feedback on an AlphaFold structure prediction, consider using the feedback buttons at the top of each structure page. If you have any questions that are not covered in the  <a href="/faq" target="_blank" class="licenseLink">FAQs</a>,</span> <span> please contact </span>
                    <span class="alphafolddeepmindcom"><a href="mailto:alphafold@deepmind.com" class="licenseLink">alphafold&#64;deepmind.com</a></span>
                    <span>. If you have feedback on the website or experience any bugs please contact </span>
                    <span class="alphafolddeepmindcom"><a href="mailto:afdbhelp@ebi.ac.uk" class="licenseLink">alphafolddb&#64;ebi.ac.uk</a></span>
                    <span class="span">.  </span>
                    <br /><br />
                    <span>Let us know how the AlphaFold Protein Structure Database has been useful in your research at  <a href="mailto:alphafold@deepmind.com" class="licenseLink">alphafold&#64;deepmind.com</a>.</span>

                </div>
            </div>
        </div>
    </div>
    <div class="citations">
        <div class="help" >Disclaimer</div>
        <div class="summary-wrapper">
            <div class="disclaimer1">
                <div class="data-is-available-container">
                    <p class="data-is-available-for-academic">The AlphaFold Data and other information provided on this site is for theoretical modelling only, caution should be exercised in its use. It is provided 'as-is' without any warranty of any kind, whether expressed or implied. For clarity , no warranty is given that use of the information shall not infringe the rights of any third party. The information is not intended to be a substitute for professional medical advice, diagnosis, or treatment, and does not constitute medical or other professional advice. </p>
                    <p class="data-is-available-for-academic">&nbsp;</p>
                    <p class="jumper-j-et-al-highly-accura">
                        <span class="data-is-available">Use of the AlphaFold Protein Structure Database is subject to EMBL-EBI </span>
                        <a class="licenseLink" href="https://www.ebi.ac.uk/about/terms-of-use/" target="_blank">
                                <span>Terms of Use</span>
                        </a>
                        <span class="data-is-available">.</span>
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>
